var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "url(#paint0_linear_1456_70511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9748 5.14844H8.67356C6.69463 5.14844 5.08936 6.75373 5.08936 8.73267V13.0339C5.08936 15.0134 6.69463 16.6181 8.67356 16.6181H12.9748C14.9543 16.6181 16.559 15.0129 16.559 13.0339V8.73267C16.559 6.75373 14.9543 5.14844 12.9748 5.14844ZM15.484 13.0339C15.484 14.4174 14.3583 15.5431 12.9748 15.5431H8.67356C7.29008 15.5431 6.16441 14.4179 6.16441 13.0339V8.73267C6.16441 7.34919 7.29008 6.22349 8.67356 6.22349H12.9748C14.3583 6.22349 15.484 7.34867 15.484 8.73267V13.0339ZM10.8242 8.01612C9.24084 8.01612 7.95651 9.29992 7.95651 10.8838C7.95651 12.4672 9.24032 13.7515 10.8242 13.7515C12.4081 13.7515 13.6919 12.4677 13.6919 10.8838C13.6919 9.29992 12.4081 8.01612 10.8242 8.01612ZM10.8242 12.6754C9.83629 12.6754 9.03209 11.8712 9.03209 10.8833C9.03209 9.89486 9.83629 9.09117 10.8242 9.09117C11.8121 9.09117 12.6163 9.89486 12.6163 10.8833C12.6163 11.8712 11.8121 12.6754 10.8242 12.6754ZM13.9069 7.41911C13.6955 7.41911 13.5249 7.59028 13.5249 7.80111C13.5249 8.01195 13.6961 8.18312 13.9069 8.18312C14.1177 8.18312 14.2889 8.01195 14.2889 7.80111C14.2889 7.58975 14.1177 7.41911 13.9069 7.41911Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1456_70511",
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3CDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111111,
    stopColor: "#9D009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222222,
    stopColor: "#C6008A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#E4007D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444444,
    stopColor: "#EF0065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555556,
    stopColor: "#FC402A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#FF4C1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#FDAF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE516"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.83cc3173e03adf653a84ab0cf6f2b2e9.svg";
export { ForwardRef as ReactComponent };